import React from "react";
import { useNavigate } from "react-router";

export interface Crumb {
  name: string;
  link?: string;
}

interface Props {
  crumbs: Crumb[];
}

const Breadcrumbs: React.FC<Props> = (props: Props) => {
  const navigate = useNavigate();

  return (
    <div className="flex text-sm text-neutral-700 gap-x-2">
      {
        props.crumbs.map((crumb, index) => (
          <div key={"crumb_" + index}>
            {
              crumb.link ? (
                <div className="flex">
                  <div className="cursor-pointer"
                       onClick={() => navigate(crumb.link ? crumb.link : "/")}>
                    {crumb.name}
                  </div>
                  <div className="ml-1">&gt;</div>
                </div>
              ) : (
                <>{crumb.name}</>
              )
            }
          </div>
        ))
      }
    </div>
  );
};

export default Breadcrumbs;
